import { render, staticRenderFns } from "./detail-kuis-5.vue?vue&type=template&id=2fe031ad&"
import script from "./detail-kuis-5.vue?vue&type=script&lang=js&"
export * from "./detail-kuis-5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CText: require('@chakra-ui/vue').CText, CImage: require('@chakra-ui/vue').CImage, CLink: require('@chakra-ui/vue').CLink, CFlex: require('@chakra-ui/vue').CFlex})
